export var modalNewsletter = function (){
	if($('#newsletter-modal').length){
		console.log('existo para funcionar');

		$('#close-newsletter-modal').click(function (){
			console.log('di clic en cerrar');
			$('#newsletter-modal').toggleClass('hide-modal');
		})

		$('.btn-newsletter').click(function(){
			console.log('di clic en registrar');
			$('#newsletter-modal').toggleClass('hide-modal');
		})

		$('.open-newsletter-modal').click(function(){
			console.log('di clic en abrir modal')
			$('#newsletter-modal').toggleClass('hide-modal');
		})
	}
}

export var popupGeneral = function (){
	if( $('#popup-general').length ){

		console.log( 'entra' );

		if(!sessionStorage.getItem('stickerboutique_popup_cookie')){
			$('#popup-general').removeClass('hide');
		}

		$('#popup-close, #popup-btn').click(function (){
			$('#popup-general').toggleClass('hide');

			//Cookie on close
			sessionStorage.setItem('stickerboutique_popup_cookie', 'true');

		})
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/modal-newsletter.js